import classNames from 'classnames';
import { Button } from 'antd';
import { useCallback, useState } from 'react';
import { ReactComponent as FaceImage } from '@/assets/images/face-recognation.svg';
import { VideoCapture } from './VideoCapture';
import ImageCapture from './ImageCapture';
import Flex from '../Flex';

export interface CaptureMediaProps {
  description: string;
  buttonStartText: string;
  onError: (error: string | DOMException) => void;
  descriptionClassname?: string;
  type?: 'image' | 'video';
  loading?: boolean;
  onInit?: () => void;
  onSubmit?: (image: File) => void;
}

export function MediaCapture({
  onInit,
  loading,
  onError,
  onSubmit,
  description,
  type = 'image',
  buttonStartText,
  descriptionClassname = undefined,
}: CaptureMediaProps) {

  const [isPreview, setIsPreview] = useState(false);

  const onStartClick = useCallback(() => {
    setIsPreview(true);
    if (onInit) {
      onInit();
    }
  }, [onInit]);

  return (
    <Flex
      align="center"
      direction="column"
      className="bg-gray-100 p-2 rounded-lg h-full max-h-full max-w-sm mx-auto">
      {isPreview ?
        (type === 'video' ?
          <VideoCapture onError={onError} loading={loading} onConfirm={onSubmit} /> :
          <ImageCapture onError={onError} loading={loading} onConfirm={onSubmit} />
        ) :
        <Flex className="h-full my-2" direction="column" align="center">
          <Flex
            direction="column"
            justify="center"
            className="w-full h-full">
            <FaceImage height="160px" />
            <p className={classNames('px-3 leading-relaxed text-base text-center', descriptionClassname)}>
              {description}
            </p>
            <Button
              size="large"
              type="primary"
              className="mx-auto"
              onClick={onStartClick}
            >{buttonStartText}</Button>
          </Flex>
        </Flex>
      }
    </Flex>
  );
}

export default MediaCapture;
